import React, { useState } from "react";
import { Link } from "react-router-dom";
import MenuItem from "./MenuItem";
import MenuDropdown from "./MenuDropdown";

export default function MenuCategory({
  categoryKey,
  categoryLink,
  categoryName,
  map,
  fragmentKey,
  linkTo,
  itemLinkTo,
  category,
  side,
}) {
  const [showCategories, setShowCategories] = useState([]);
  const [showCategory, setShowCategory] = useState(-1);

  const toggleCategory = (categoryId) => {
    let updatedShowCategories = [...showCategories];
    const categoryIdx = updatedShowCategories.indexOf(categoryId);
    if (categoryIdx > -1) {
      updatedShowCategories.splice(categoryIdx, 1);
    } else {
      updatedShowCategories.push(categoryId);
    }
    setShowCategories(updatedShowCategories);
  };

  const toggleSingleCategory = (categoryId) => {
    setShowCategory(categoryId);
  };

  return (
    <li key={categoryKey} className="dropdown ml-2 lg:ml-0">
      {map.length > 0 ? (
        <>
          <Link
            to={categoryLink}
            // onMouseEnter={() => toggleSingleCategory(category.id)}
            // onMouseLeave={() => toggleSingleCategory(category.id)}
            className="hidden lg:inline-flex py-2 px-2 font-semibold whitespace-no-wrap hover:text-pink-350 transition-all"
          >
            {categoryName}
            {/* &#x23f7; */}
          </Link>
          <Link
            className="inline-flex lg:hidden py-2 px-2 font-semibold items-center uppercase"
            // onClick={() => toggleCategory(category.id)}
            to={categoryLink}
          >
            {categoryName}{" "}
            {/* {showCategories.indexOf(category.id) > -1 ? <>&#x23f7;</> : <>&#x23f5;</>} */}
          </Link>
        </>
      ) : null}
      {showCategory === category.id ? (
        <ul
          className={`dropdown-content lg:absolute lg:hidden bg-white pl-5 ${
            side === "left" ? "lg:-ml-56" : "lg:ml-36"
          } lg:-mt-10 w-56`}
        >
          {!map ? (
            <>
              {map.map((subcategory) => (
                <MenuItem
                  key={`menu-item-${subcategory.id}`}
                  linkTo={linkTo`/${subcategory.id}`}
                  name={subcategory.name}
                />
              ))}
            </>
          ) : map ? (
            <>
              {
                <React.Fragment key={fragmentKey}>
                  {map.length > 1
                    ? map.map((subcategory) => (
                        <MenuDropdown
                          key={`menu-dropdown-${subcategory.id}`}
                          subKey={subcategory.subKey}
                          subLinkTo={`${linkTo}/${subcategory.id}`}
                          subName={subcategory.name}
                          map={subcategory.menuItem}
                          itemLinkTo={itemLinkTo}
                          subCat={subcategory}
                          side={side}
                        />
                      ))
                    : null}
                  {map?.length === 1
                    ? map[0]
                      ? map[0]?.menuItem
                          ?.sort((a, b) => a.id - b.id)
                          .map((item) => (
                            <MenuItem
                              key={`menu-item-${item.id}-${item.name}`}
                              linkTo={`${itemLinkTo}/${map[0].id}/${item.id}/${map[0]?.itemId}`}
                              name={item.name}
                            />
                          ))
                      : null
                    : null}
                </React.Fragment>
              }
            </>
          ) : null}
        </ul>
      ) : null}
      {showCategories.indexOf(category.id) > -1 ? (
        <ul className="dropdown-content lg:absolute lg:hidden bg-white pl-5 lg:ml-36 lg:-mt-10 w-56">
          {!map ? (
            <>
              {map.map((subcategory) => (
                <MenuItem
                  key={`menu-item-${subcategory.id}`}
                  linkTo={linkTo`/${subcategory.id}`}
                  name={subcategory.name}
                />
              ))}
            </>
          ) : map ? (
            <>
              {
                <React.Fragment key={fragmentKey}>
                  {map.length > 1
                    ? map.map((subcategory) => (
                        <MenuDropdown
                          key={`menu-dropdown-${subcategory.id}`}
                          subKey={subcategory.subKey}
                          subLinkTo={`${linkTo}/${subcategory.id}`}
                          subName={subcategory.name}
                          map={subcategory.menuItem}
                          itemLinkTo={itemLinkTo}
                          subCat={subcategory}
                        />
                      ))
                    : null}
                  {map?.length === 1
                    ? map[0]
                      ? map[0]?.menuItem
                          ?.sort((a, b) => a.id - b.id)
                          .map((item) => (
                            <MenuItem
                              key={`menu-item-${item.id}-${item.name}`}
                              linkTo={`${itemLinkTo}/${map[0].id}/${item.id}/${map[0]?.itemId}`}
                              name={item.name}
                            />
                          ))
                      : null
                    : null}
                </React.Fragment>
              }
            </>
          ) : null}
        </ul>
      ) : null}
    </li>
  );
}
